import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/components/ui/breadcrumb';
import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import React from 'react';
import type { BreadcrumbSegment } from './breadcrumbUtils';

interface LayoutBreadcrumbProps {
  segments: BreadcrumbSegment[];
}

export const LayoutBreadcrumb: React.FC<LayoutBreadcrumbProps> = ({
  segments,
}) => (
  <Breadcrumb className="min-w-0">
    {/* 모바일은 폭이 좁아 현재 화면 이름만 보여 준다 */}
    <BreadcrumbList className="flex-nowrap">
      {segments.map((segment, index) => {
        const Icon = segment.icon;
        const isLast = index === segments.length - 1;
        // path만 쓰면 홈·대시보드처럼 동일 path가 두 번 나와 key 충돌
        const key = `${segment.path ?? segment.label}-${index}`;

        return (
          <React.Fragment key={key}>
            <BreadcrumbItem className={isLast ? 'min-w-0' : 'max-sm:hidden'}>
              {isLast || !segment.path ? (
                <BreadcrumbPage className="flex min-w-0 items-center gap-1.5 font-medium">
                  {Icon ? <Icon className="h-3.5 w-3.5 shrink-0" /> : null}
                  <span className="truncate">{segment.label}</span>
                </BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={segment.path} className="flex items-center gap-1.5">
                    {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
                    {segment.label}
                  </Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
            {!isLast ? (
              <BreadcrumbSeparator className="max-sm:hidden">
                <ChevronRight className="h-3.5 w-3.5" />
              </BreadcrumbSeparator>
            ) : null}
          </React.Fragment>
        );
      })}
    </BreadcrumbList>
  </Breadcrumb>
);
